module.exports = __webpack_public_path__ + "static/img/mouse_icon.a2fa6861.svg";